import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ClassesPage } from '~/components/admin/classes-page'
import { PageHeader } from '~/components/app-shell'

export const Route = createFileRoute('/_authed/_admin/admin/classes')({
  validateSearch: z.object({
    q: z.string().max(100).catch('').default(''),
    page: z.number().int().min(0).catch(0).default(0),
  }),
  head: () => ({ meta: [{ title: `${m.admin_nav_classes()} – ${m.app_name()}` }] }),
  component: ClassesRoute,
})

function ClassesRoute() {
  const { q, page } = Route.useSearch()
  return (
    <>
      <PageHeader title={m.admin_nav_classes()} description={m.admin_classes_description()} />
      <ClassesPage q={q} page={page} />
    </>
  )
}
